export default __webpack_public_path__ + "static/media/title_ja_pc@2x.afb95a0d.png";